import axios from "axios";
import { useContext, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useAlert } from "react-bootstrap-hooks-alert";
import eventContext from "../Contexts/EventContexts";
import { urlEvent, urlMatchData, urlTeamAverages } from "../endpoints";
import Button from "../Utils/Button";
import {MatchDTO } from "../Utils/Utils.models";
import { utils } from 'xlsx';
import FileSelect from "../Utils/FileSelect";
import EventSelector from "../Utils/EventSelector";
import { matchDataDTO } from "../TeamParser/TeamParser.model";
import { MatchExcelDataDTO } from "./MatchDataImport.model";


export default function MatchDataImport() {

    const { eventCode, updateEvent } = useContext(eventContext);
    const [selectedFile, setSelectedFile] = useState<File>();

    const { danger, success } = useAlert();

    async function importData() {
        if (selectedFile) {
            var XLSX = require("xlsx");

            const data = await selectedFile!.arrayBuffer();
            const workbook = XLSX.read(data);
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            let newMatches: matchDataDTO[] = []
            for (let i = 1; i < rawData.length; i++) {
                let newMatch: matchDataDTO = {
                    eventCode: eventCode,
                    teamNumber: rawData[i][1],
                    matchNumber: rawData[i][3],
                    startingPosition: rawData[i][25],
                    autoLow: rawData[i][9],
                    autoMid: rawData[i][8],
                    autoHigh: rawData[i][7],
                    autoChargeStation: rawData[i][6],
                    teleLow: rawData[i][12],
                    teleMid: rawData[i][11],
                    teleHigh: rawData[i][10],
                    endChargeStation: rawData[i][17],
                }
                newMatches.push(newMatch)
            }


            await axios.post(`${urlMatchData}/savedata`, newMatches).then(() => {
                axios.get(`${urlTeamAverages}/calculateAverages/`, {
                    params: {
                        eventID: eventCode
                    },
                }).then(() => {
                    success("Successfully Imported Match Data");
                })

            })
        } else {
            danger("Please select file");
        }
    }

    return (<>
        <div className="container w-75" >
            <h4 className="text-center align-middle">Import Match Data</h4>

            <Row className='mt-3'>
                <Col className='col-md-auto mt-1'><h5>Select Event: </h5></Col>
                <Col>
                    <EventSelector ></EventSelector>
                </Col>
                <Col className='col-md-auto mt-1'><h5>Select Excel: </h5></Col>
                <Col>
                    <FileSelect onSelect={setSelectedFile}></FileSelect> 
                </Col>
            </Row>
            <Row><Button className="btn btn-primary btn-block" onClick={importData} >Import Data</Button></Row>
        </div>
    </>)
}